<template>
	<div class="tab-pane" id="domainDetails">
    <h3 class="info-text mb-0">Domain Details</h3>
    <p class="text-center text-secondary mb-4">
      <em>DNS &amp; Domain Registar Details</em>
    </p>
    <div class="row justify-content-center">
      <div class="col-12 pr-5 pl-5">
				<div class="row border-bottom-color-line">
					<div class="col-12">
						<div class="form-group">
              <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : dnsByBigscoots, 'bootstrap-switch-off bootstrap-switch-focused' : !dnsByBigscoots }">
                <div class="bootstrap-switch-container" @click="dnsByBigscoots = !dnsByBigscoots">
                  <span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
                  <span class="bootstrap-switch-label"></span>
                  <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
                </div>
              </div>
              <label for="haveSSH" class="ml-2" style="font-size: 14px;">
                Do you want BigScoots to handle your DNS changes? <span class="badge bg-teal">Highly Recommended</span>
              </label>
            </div>
					</div>
					<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="in-out">
						<div class="col-12 mt-4" v-if="!dnsByBigscoots">
							<div class="alert bg-midnight-blue">Since you have selected to <strong>manage the DNS yourself</strong>, we will notify you of the required DNS changes once the migration has completed.</div>
						</div>
					</transition>
					<transition-group tag="div" class="col-12 p-0" :class="`mig-${migrationListDetails.length}`" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" move-class="animated fadeIn" v-if="dnsByBigscoots">
						<div class="col-12" :class="{ 'border-top': index === 0, 'border-bottom': index !== migrationList.length - 1}" v-for="(acc, index) in migrationList"  :key="`index-${acc.domain}`">
							<div class="migration-details mt-3 mb-1">
								<span class="d-inline-block mr-4"><strong>{{ acc.domain }}</strong></span>
								<div v-if="acc.currentHost.name !== 'SiteGround'" class="form-group d-inline-block">
									<div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : acc.domainRegSameAsHost, 'bootstrap-switch-off bootstrap-switch-focused' : !acc.domainRegSameAsHost }">
										<div class="bootstrap-switch-container" @click="toggleSwitch(index)">
											<span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
											<span class="bootstrap-switch-label"></span>
											<span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
										</div>
									</div>
									<label for="haveSSH" class="ml-2" style="font-size: 14px;">
										Copy from current host information.
		<!--Is this domain registered with the same place it is currently hosted?-->
									</label>
								</div>

								<div class="col-12">
									<p>
										<span class="badge badge-info mb-0">Please Note</span>
										This is the login to where your domain is registered which may or may not be where you are currently hosting. Typically its
										best to provide the billing login information.
									</p>
								</div>
								<div class="row">
									<div v-if="acc.domainAccessGranted" class="col-12">
										<button class="btn btn-default btn-round btn-sm d-block pull-right" @click="resetHostFields(index)">
											Reset Host Fields
										</button>
									</div>
								</div>
								<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
									<div class="row animated fadeIn" >
										<div class="col-sm-12 col-md-6" key="domainRegistarName">
											<div class="form-group">
												<label for="domainRegisterName">Name of Current Domain Registar
													<strong class="text-danger">*</strong>
												</label>
												<select class="form-control domain-registar-name" :disabled="acc.domainRegSameAsHost"  @change="changedHost(acc.domainRegistar.name, index)" :name="`domainRegisterName_${index}`" aria-describedby="domainRegisterName" required @input="domainRegisterNameValid" v-model.trim="acc.domainRegistar.name">
													<option value="">Select Domain Registrar</option>
													<option v-for="host in commonHosts" :value="host" :key="host">{{host}}</option>
												</select>
<!--												<input type="text" class="form-control domain-registar-name" :name="`domainRegisterName_${index}`" aria-describedby="domainRegisterName" placeholder="Example: GoDaddy" required @input="domainRegisterNameValid" v-model.trim="acc.domainRegistar.name">-->
											</div>
										</div>
										<div class="col-sm-12 col-md-6" v-if="acc.domainShowAccessBtn">
											<button class="btn btn-primary btn-round d-block mt-4" data-toggle="modal"
															data-target="#domian-access-video" @click.prevent="fixModal(index)">
												Give BigScoots Access
											</button>
										</div>
										<div class="col-sm-12 col-md-6" key="domainRegistarURL" v-if="!acc.domainShowAccessBtn">
											<div class="form-group">
												<label for="domainRegistarURL">Domain Panel Web Address
													<strong class="text-danger">*</strong>
												</label>
												<input type="text" :readonly="acc.domainRegSameAsHost"  :disabled="acc.domainRegistar.url === 'Access granted'"  class="form-control domain-register-url" :name="`domainRegistarURL_${index}`" aria-describedby="domainRegistarURL" placeholder="Example: https://www.godaddy.com" required @input="domainRegisterURLValid" v-model.trim="acc.domainRegistar.url">
											</div>
										</div>
										<div class="col-sm-12 col-md-6" key="domainRegisterUsername" v-if="!acc.domainShowAccessBtn">
											<div class="form-group">
												<label for="domainRegisterUsername">Domain Panel Username
													<strong class="text-danger">*</strong>
												</label>
												<input type="text" :readonly="acc.domainRegSameAsHost" :disabled="acc.domainRegistar.username === 'Access granted'" class="form-control domain-register-username" :name="`domainRegistarUsername_${index}`" aria-describedby="domainRegistarUsername" required @input="domainRegisterUsernameValid" v-model.trim="acc.domainRegistar.username">
											</div>
										</div>
										<div class="col-sm-12 col-md-6" key="domainRegisterPassword" v-if="!acc.domainShowAccessBtn">
											<div class="form-group">
												<label for="domainRegisterPassword">Domain Panel Password
													<strong class="text-danger">*</strong>
												</label>
												<input type="text" :readonly="acc.domainRegSameAsHost" :disabled="acc.domainRegistar.password === 'Access granted'" class="form-control domain-register-password" :name="`domainRegistarPassword_${index}`" aria-describedby="domainRegistarPassword" required @input="domainRegisterPassValid" v-model.trim="acc.domainRegistar.password">
											</div>
										</div>
									</div>
								</transition>
							</div>
						</div>
					</transition-group>
				</div>
        <div class="row">
          <div class="col-12">
            <p class="text-center text-info mt-4" style="font-size: 1.2rem;">
              <i class="fa fa-question-circle mr-2" aria-hidden="true"></i>
              <strong>NOTE - </strong>
              <a class="text-info" href="http://help.bigscoots.com/en/articles/5046130-domain-registrar-information" target="_blank">
                I do not know where my domain is registered!
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
		<host-video-modal id="domian-access-video" :host="selectedHost" />
	</div>
</template>

<script>
import { eventBus } from "@/main";
import copyButtonMixin from '../../../../mixins/copyButtonMixin';
import hostVideoModal from "../../hostVideoModal";

export default {
  name: "DomainAndDnsDetails",
  mixins: [copyButtonMixin],
	components: {
		hostVideoModal
	},
  data() {
    return {
      migrationList: [],
			hostAccessRemainingDomains: [],
		commonHosts: [
			'WPOPT',
			'OrangeGeek',
			'WP Engine',
			'FlyWheel',
			'BlueHost',
			'HostGator',
			'GoDaddy',
			'Kinsta',
			'SiteGround',
			'Other'
		],
		addAddonDomainIndex: null,
		denied: false
    }
  },
  computed: {
    dnsByBigscoots: {
      get() {
        return this.$store.getters["migration/dnsByBigscoots"];
      },
      set(newState) {
        this.$store.commit("migration/dnsByBigscootsMutate", {
          state: newState
        });
      }
    },
    migrationListDetails() {
      return this.$store.getters["migration/migrationList"];
    },
		videoAccessGrantedOrDenied() {
			return this.hostAccessRemainingDomains.length <= 0
		},
		selectedHost () {
    	return (this.addAddonDomainIndex !== null) ? this.migrationList[this.addAddonDomainIndex].domainRegistar.name : ''
		}
  },
	watch: {
		videoAccessGrantedOrDenied (value) {
			this.$store.commit("migration/mutateHostVideoAccessResponseFlag", value);
		}
	},
  methods: {
		resetHostFields (index) {
      this.denied = false
      this.migrationList[index].domainAccessGranted = false
			this.migrationList[index].domainRegistar.password = null;
			this.migrationList[index].domainRegistar.username = null;
			this.migrationList[index].domainRegistar.url = null;
			this.migrationList[index].domainRegistar.name = '';
			if (this.hostAccessRemainingDomains.includes(index)) {
				this.hostAccessRemainingDomains.splice(this.hostAccessRemainingDomains.indexOf(index), 1)
			}
		},
		grantedAccess () {
      this.denied = false
			if (this.hostAccessRemainingDomains.includes(this.addAddonDomainIndex)) {
				this.hostAccessRemainingDomains.splice(this.hostAccessRemainingDomains.indexOf(this.addAddonDomainIndex), 1)
			}
      this.migrationList[this.addAddonDomainIndex].domainAccessGranted = true
      this.migrationList[this.addAddonDomainIndex].domainShowAccessBtn = false
			this.migrationList[this.addAddonDomainIndex].domainRegistar.password = 'Access granted';
			this.migrationList[this.addAddonDomainIndex].domainRegistar.username = 'Access granted';
			this.migrationList[this.addAddonDomainIndex].domainRegistar.url = 'Access granted';
		},
		deniedAccess () {
      this.denied = true
			if (this.hostAccessRemainingDomains.includes(this.addAddonDomainIndex)) {
				this.hostAccessRemainingDomains.splice(this.hostAccessRemainingDomains.indexOf(this.addAddonDomainIndex), 1)
			}
      this.migrationList[this.addAddonDomainIndex].domainShowAccessBtn = false
      this.migrationList[this.addAddonDomainIndex].domainAccessGranted = false
			this.migrationList[this.addAddonDomainIndex].domainRegistar.password = null;
			this.migrationList[this.addAddonDomainIndex].domainRegistar.username = null;
			this.migrationList[this.addAddonDomainIndex].domainRegistar.url = null;
		},
		changedHost (value, index) {
      this.denied = false
      this.migrationList[index].domainAccessGranted = null
			this.migrationList[index].domainRegistar.password = null;
			this.migrationList[index].domainRegistar.username = null;
			this.migrationList[index].domainRegistar.url = null;
			if (value === 'GoDaddy') {
        this.migrationList[index].domainShowAccessBtn = true
				if (!this.hostAccessRemainingDomains.includes(index)) {
					this.hostAccessRemainingDomains.push(index)
				}
			} else {
        this.migrationList[index].domainShowAccessBtn = false
				if (this.hostAccessRemainingDomains.includes(index)) {
					this.hostAccessRemainingDomains.splice(this.hostAccessRemainingDomains.indexOf(index), 1)
				}
			}
		},
		fixModal(index) {
			this.addAddonDomainIndex = index;
			/* eslint-disable */
			$(document).ready(function () {
				$(".modal-backdrop").appendTo(".add-addon-domain-modal");
				$('.modal-backdrop').removeClass("modal-backdrop");
			});
			/* eslint-enable */
		},
	toggleSwitch(index){
		if (this.hostAccessRemainingDomains.includes(index)) {
			this.hostAccessRemainingDomains.splice(this.hostAccessRemainingDomains.indexOf(index), 1)
		}
		this.migrationList[index].domainShowAccessBtn = false
		this.migrationList[index].domainRegSameAsHost = !this.migrationList[index].domainRegSameAsHost;
		if(this.migrationList[index].domainRegSameAsHost){
			console.log(this.migrationList[index]);
			if(this.migrationList[index].hostSameAsAbove){
				this.migrationList[index].domainRegistar.name = this.migrationList[0].currentHost.name;
				this.migrationList[index].domainRegistar.password = this.migrationList[0].currentHost.password;
				this.migrationList[index].domainRegistar.url = this.migrationList[0].currentHost.url;
				this.migrationList[index].domainRegistar.username = this.migrationList[0].currentHost.username;
			}else{
				this.migrationList[index].domainRegistar.name = this.migrationList[index].currentHost.name;
				this.migrationList[index].domainRegistar.password = this.migrationList[index].currentHost.password;
				this.migrationList[index].domainRegistar.url = this.migrationList[index].currentHost.url;
				this.migrationList[index].domainRegistar.username = this.migrationList[index].currentHost.username;
			}

		}else{
			this.migrationList[index].domainRegistar.name = '';
			this.migrationList[index].domainRegistar.password = '';
			this.migrationList[index].domainRegistar.url = '';
			this.migrationList[index].domainRegistar.username = '';
		}
	},
    domainRegisterNameValid() {
      /* eslint-disable */
      $(".domain-registar-name").valid();
      /* eslint-enable */
    },
    domainRegisterURLValid() {
      /* eslint-disable */
      $(".domain-register-url").valid();
      /* eslint-enable */
    },
    domainRegisterUsernameValid() {
      /* eslint-disable */
      $(".domain-register-username").valid();
      /* eslint-enable */
    },
    domainRegisterPassValid() {
      /* eslint-disable */
      $(".domain-register-password").valid();
      /* eslint-enable */
    }
  },
  created() {
    eventBus.$on("nextPage", data => {
      // Only execute if the page is going from domain details to additional details
      if (data.page === 'domain details') {
        this.$store.dispatch("migration/migrationListUpdate", {
          list: this.migrationList
        });
      }
    });
  },
  updated() {
    this.migrationList = this.migrationListDetails

    /* eslint-disable */
    $(document).ready(function() {
      $('[name*="domainRegisterName"]').each(function() {
        $(this).rules('add', {
          required: true
        });
      });

      $('[name*="domainRegistarURL"]').each(function() {
        $(this).rules('add', {
          required: true
        });
      });

      $('[name*="domainRegistarUsername"]').each(function() {
        $(this).rules('add', {
          required: true
        });
      });

      $('[name*="domainRegistarPassword"]').each(function() {
        $(this).rules('add', {
          required: true
        });
      });
    });
    /* eslint-enable */
  }
};
</script>
